// extracted by mini-css-extract-plugin
module.exports = {"theme":"Theme_theme__Chl4d","input":"Theme_input__3-WN5","inner":"Theme_inner__1n7Uu","box":"Theme_box__2pvh1","themeBig":"Theme_themeBig__1SRXv"};